/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */
import React from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import {
  MapPin,
  Phone,
  Instagram,
  Linkedin,
  Github,
  ArrowUp,
} from "lucide-react";
import BrandIcon from "./BrandIcon";
import Button from "../elements/Button";

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="relative pb-6 overflow-hidden border-t border-gray-200 bg-gray-50">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute w-32 h-32 bg-gray-300 rounded-full top-10 left-10" />
        <div className="absolute w-24 h-24 bg-gray-400 rounded-full bottom-10 right-10" />
        <div className="absolute w-16 h-16 bg-gray-300 rounded-full top-1/2 left-1/3" />
      </div>

      <div className="container relative z-10 px-6 mx-auto">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 gap-8 mt-12 mb-8 md:grid-cols-2 lg:grid-cols-4">
          {/* Brand Section */}
          <div className="space-y-6 lg:col-span-2">
            <div className="transition-transform duration-300 transform hover:scale-105">
              <BrandIcon />
            </div>
            <p className="max-w-md text-lg font-light leading-relaxed text-gray-600">
              Our core mandate is to empower startups, SMEs, real estate
              developers, and investors through access to capital, financial
              services, and digital innovation.
            </p>

            {/* Quick Stats */}
            <div className="grid max-w-md grid-cols-3 gap-4">
              <div className="p-3 text-center transition-shadow duration-300 bg-white rounded-lg shadow-sm hover:shadow-md">
                <div className="text-2xl font-bold text-theme-blue">500+</div>
                <div className="text-xs text-gray-500">Companies</div>
              </div>
              <div className="p-3 text-center transition-shadow duration-300 bg-white rounded-lg shadow-sm hover:shadow-md">
                <div className="text-2xl font-bold text-theme-blue">$2.5B</div>
                <div className="text-xs text-gray-500">Managed</div>
              </div>
              <div className="p-3 text-center transition-shadow duration-300 bg-white rounded-lg shadow-sm hover:shadow-md">
                <div className="text-2xl font-bold text-theme-blue">15x</div>
                <div className="text-xs text-gray-500">Avg Return</div>
              </div>
            </div>
          </div>

          {/* Office Section */}
          <div className="space-y-6">
            <h2 className="flex items-center mb-4 text-xl font-semibold text-theme-blue">
              <MapPin className="w-5 h-5 mr-2" />
              Office
            </h2>

            <div className="space-y-4">
              <div className="flex items-start p-3 space-x-3 transition-colors duration-300 rounded-lg group hover:bg-white">
                <Phone className="w-5 h-5 mt-1 text-theme-blue group-hover:animate-pulse" />
                <div>
                  <p className="text-lg font-medium text-gray-700">
                    903-293-2500
                  </p>
                  <p className="text-sm text-gray-500">Call us anytime</p>
                </div>
              </div>

              <div className="flex items-start p-3 space-x-3 transition-colors duration-300 rounded-lg group hover:bg-white">
                <MapPin className="w-5 h-5 mt-1 text-theme-blue group-hover:animate-pulse" />
                <div>
                  <p className="text-lg font-medium text-gray-700">
                    101 Redwater Road Apt 249,
                    <br />
                    Wake Village TX 75501
                  </p>
                  <p className="text-sm text-gray-500">
                    Visit our headquarters
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Social Section */}
          <div className="space-y-6">
            <h2 className="mb-4 text-xl font-semibold text-theme-blue">
              Connect With Us
            </h2>

            <div className="space-y-3">
              <Button
                href="https://www.instagram.com/"
                type="link"
                target="_blank"
                className="flex items-center w-full p-3 space-x-3 text-left transition-all duration-300 transform rounded-lg group hover:bg-white hover:translate-x-1"
                isExternal
              >
                <Instagram className="w-5 h-5 text-pink-500 group-hover:animate-bounce" />
                <span className="text-lg font-light text-gray-600 group-hover:text-gray-800">
                  Instagram
                </span>
              </Button>

              <Button
                href="https://www.linkedin.com/"
                type="link"
                target="_blank"
                className="flex items-center w-full p-3 space-x-3 text-left transition-all duration-300 transform rounded-lg group hover:bg-white hover:translate-x-1"
                isExternal
              >
                <Linkedin className="w-5 h-5 text-blue-600 group-hover:animate-bounce" />
                <span className="text-lg font-light text-gray-600 group-hover:text-gray-800">
                  LinkedIn
                </span>
              </Button>

              <Button
                href="https://github.com/"
                type="link"
                target="_blank"
                className="flex items-center w-full p-3 space-x-3 text-left transition-all duration-300 transform rounded-lg group hover:bg-white hover:translate-x-1"
                isExternal
              >
                <Github className="w-5 h-5 text-gray-700 group-hover:animate-bounce" />
                <span className="text-lg font-light text-gray-600 group-hover:text-gray-800">
                  Github
                </span>
              </Button>
            </div>

            {/* Newsletter Signup */}
            <div className="p-4 mt-6 bg-white rounded-lg shadow-sm">
              <h3 className="mb-2 text-sm font-semibold text-gray-700">
                Stay Updated
              </h3>
              <div className="flex items-center w-full space-x-2">
                <input
                  type="email"
                  placeholder="Enter email"
                  className="flex-1 min-w-0 px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-theme-blue focus:border-transparent"
                />
                <button
                  type="button"
                  className="flex-shrink-0 px-4 py-2 text-sm text-white transition-colors duration-300 rounded-md bg-theme-blue hover:bg-blue-700 whitespace-nowrap"
                >
                  Subscribe
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="pt-8 border-t border-gray-200">
          <div className="flex flex-col items-center justify-between space-y-4 md:flex-row md:space-y-0">
            <div className="text-center md:text-left">
              <p className="text-lg font-light text-gray-500">
                Copyright 2024 - All rights reserved - katellaventurecapital
              </p>
              <div className="flex justify-center mt-2 space-x-6 md:justify-start">
                <a
                  href="/"
                  className="text-sm text-gray-400 transition-colors duration-300 hover:text-theme-blue"
                >
                  Privacy Policy
                </a>
                <a
                  href="/"
                  className="text-sm text-gray-400 transition-colors duration-300 hover:text-theme-blue"
                >
                  Terms of Service
                </a>
                <a
                  href="/"
                  className="text-sm text-gray-400 transition-colors duration-300 hover:text-theme-blue"
                >
                  Cookie Policy
                </a>
              </div>
            </div>

            {/* Back to Top Button */}
            <button
              type="button"
              onClick={scrollToTop}
              className="flex items-center px-6 py-3 space-x-2 transition-all duration-300 transform bg-white border border-gray-300 rounded-full group hover:bg-theme-blue hover:text-white hover:border-theme-blue hover:scale-105"
            >
              <ArrowUp className="w-4 h-4 group-hover:animate-bounce" />
              <span className="text-sm font-medium">Back to Top</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
